
import React, { Component } from "react";
import { Row, Column } from "react-foundation";
// slider
import Slider from 'rc-slider';
import Loading from "../../components/Loading";
import utils from "utils";
import Tooltip from 'rc-tooltip';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const SliderWithTooltip = createSliderWithTooltip(Slider);

export default class SelectSize extends Component {
    componentDidUpdate() {
        const { loading, range, ConservatorySize } = this.props;

        const widthHasValue = ConservatorySize.Width.input.value !== 0;
        const heightHasValue = ConservatorySize.Height.input.value !== 0;

        const initialWidth = widthHasValue ? ConservatorySize.Width.input.value : utils.convertWindowSize(range.MinWidth, "mm", "m"); 
        const initialHeight = heightHasValue ? ConservatorySize.Height.input.value : utils.convertWindowSize(range.MinHeight, "mm", "m"); 

        if(!loading && !ConservatorySize.Width.input.value ){
            ConservatorySize.Width.input.onChange(initialWidth);
        }
        if(!loading && !ConservatorySize.Height.input.value ){
            ConservatorySize.Height.input.onChange(initialHeight);
        }
    }

    getConvertedRange = (unit) => {
        const { range } = this.props;
        return {
            MinWidth: Math.round(utils.convertWindowSize(range.MinWidth, "mm", unit)),
            MaxWidth: Math.round(utils.convertWindowSize(range.MaxWidth, "mm", unit)),
            MinHeight: Math.round(utils.convertWindowSize(range.MinHeight, "mm", unit)),
            MaxHeight: Math.round(utils.convertWindowSize(range.MaxHeight, "mm", unit)),
        };
    }

    getMarks = (convertedRange) => {
        let marks = {};
        Object.keys(convertedRange).forEach((key) => {
            const val = convertedRange[key];
            marks[val] = {
                style: {
                    color: 'grey'
                },
                label: <strong>{val}</strong>,
            }
        });
        return marks;
    }

    getScale = (convertedRange) => {
        let windowWidth = window.outerWidth;
        const componentWidth = windowWidth >= 767 ? 355 : 255;
        return componentWidth / convertedRange.MaxWidth;
    }

    handleWidthChange = (value) => {
        const { range, ConservatorySize } = this.props;
        const unit = ConservatorySize.Unit.input.value;
        const minWidth = utils.convertWindowSize(range.MinWidth, "mm", unit);

        if(value >= minWidth){
            ConservatorySize.Width.input.onChange(value);
        }
    }
    handleHeightChange = (value) => {
        const { range, ConservatorySize } = this.props;
        const unit = ConservatorySize.Unit.input.value;
        const minHeight = utils.convertWindowSize(range.MinHeight, "mm", unit);

        if(value >= minHeight){
            ConservatorySize.Height.input.onChange(value);
        }
    }

    toggleUnit = (newUnit, conservatoryWidth, conservatoryHeight) => {

        const { ConservatorySize } = this.props;
        const newWidth = utils.convertWindowSize(conservatoryWidth, ConservatorySize.Unit.input.value, newUnit);
        const newHeight = utils.convertWindowSize(conservatoryHeight, ConservatorySize.Unit.input.value, newUnit);
        ConservatorySize.Width.input.onChange(newWidth);
        ConservatorySize.Height.input.onChange(newHeight);
        ConservatorySize.Unit.input.onChange(newUnit);
    }

    // handleChange(value) {
    //     for (let key in value) {
    //         this.props.ConservatorySize[key].input.onChange(value[key]);
    //     }
    // }

    // componentWillMount() {
    //     this.handleChange({
    //         Approximate: "medium",
    //         Type: "approximate",
    //         Width: null,
    //         Height: null
    //     });  
    // }

    getTooltip = (props, toolTipHandler, unit) => {
        const { value, dragging, index, ...restProps } = props;
        const { Handle }  = Slider;
        console.log(props)
        return (
          <Tooltip
            prefixCls="slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
          >
            <Handle {...restProps} />
          </Tooltip>
        );
    }

    normalizeSize(onChange, min, max) {
        return e => {
            let val = e.target.value;
            // replace any non number character
            val = val.replace(/([^0-9.])/i, "");
            // remove any period after the first one
            val = val.replace(
                /\./g,
                (char, index, str) => (str.indexOf(char) === index ? char : "")
            );
            // remove any char after 2 dp
            val = val.replace(/(\.\d{0,2})\d*/, "$1");
            
            if(val < min){val = min}
            if(val > max){val = max}

            onChange(val);
        };
    }



    render() {
        // let { loading, ConservatorySize, ConservatorySize: { Width, Height, Unit, Approximate, Type } } = this.props;
        let { loading, ConservatorySize } = this.props;

        const unit = ConservatorySize.Unit.input.value;
        const convertedRange = this.getConvertedRange(unit);
        const conservatoryWidth = ConservatorySize.Width.input.value;
        const conservatoryHeight = ConservatorySize.Height.input.value;
        const scale = this.getScale(convertedRange);
        if(loading){
            return <Loading />;
        }
        
        return (
        <Row>
            <Column
                large={12}
                className="size-control"
            >
                <Row className="size-image">
                    <div>
                        {unit === "m" ? (
                            <h5 className="door-size-value">Width: {Math.round(conservatoryWidth * 10) / 10} {unit} / Projection: {Math.round(conservatoryHeight * 10) / 10} {unit}</h5>
                            ):(
                            <h5 className="door-size-value">Width: {utils.percentFormatter(conservatoryWidth)} / Projection: {utils.percentFormatter(conservatoryHeight)}</h5>
                        )}
                    </div>
                    {/* <Row style={{paddingTop: "15px"}}>
                        <Column
                            small={6}
                            className="hidden-on-large"
                        >
                            <p>Projection({ConservatorySize.Unit.input.value}):</p>
                            <input
                                type="number"
                                {...Height.input}
                                onChange={this.normalizeSize(
                                    Height.input.onChange, 
                                    convertedRange.MinHeight, 
                                    convertedRange.MaxHeight
                                )}
                                onBlur={() => {
                                    this.handleHeightChange
                                }}
                                className="height"
                            />
                        </Column>
                        <Column
                            small={6}
                            className="hidden-on-large"
                        >
                            <p>Width({ConservatorySize.Unit.input.value}):</p>
                            <input
                                type="number"
                                {...Width.input}
                                onChange={this.normalizeSize(
                                    Width.input.onChange, 
                                    convertedRange.MinWidth, 
                                    convertedRange.MaxWidth
                                )}
                                onBlur={() =>
                                    this.handleWidthChange
                                }
                                className="width"
                            />
                        </Column>
                    </Row> */}
                    <div className="conservatory-frame" style={{ width: `${convertedRange.MaxWidth * scale}px`}}>
                        <div className="conservatory-size" style={{ width: `${conservatoryWidth * scale}px`, height: `${conservatoryHeight * scale}px`}}>
                        </div>
                        <SliderWithTooltip
                            defaultValue={convertedRange.MinWidth}
                            marks={this.getMarks(convertedRange)}
                            min={0}
                            max={convertedRange.MaxWidth}
                            onChange={this.handleWidthChange}
                            step={(unit === "m" ? 0.1 : 1/3)}
                            value={Number(conservatoryWidth)}
                            tipFormatter={ v => utils.percentFormatter(v, unit)}
                        />
                        {/* INPUT FOR HEIGHT SLIDER */}
                        {/* <p className="height-input-text hidden-on-small">Projection({ConservatorySize.Unit.input.value}):</p> */}
                        {/* <input
                            type="number"
                            {...Height.input}
                            onChange={this.normalizeSize(
                                Height.input.onChange, 
                                convertedRange.MinHeight, 
                                convertedRange.MaxHeight
                            )}
                            onBlur={() => {
                                this.handleHeightChange
                            }}
                            className="height width-input hidden-on-small"
                        /> */}
                        <span>
                            <SliderWithTooltip 
                                defaultValue={convertedRange.MinHeight}
                                marks={this.getMarks(convertedRange)}
                                vertical={true}
                                min={0}
                                max={convertedRange.MaxHeight}
                                onChange={this.handleHeightChange}
                                step={(unit === "m" ? 0.1 : 1/3)}
                                value={Number(conservatoryHeight)}
                                tipFormatter={ v => utils.percentFormatter(v, unit)}
                            />
                         
                            {/* INPUT FOR WIDTH SLIDER */}
                            {/* <p className="width-input-text hidden-on-small">Width({ConservatorySize.Unit.input.value}):</p>
                            <input
                                hidden={isMobile}
                                type="number"
                                {...Width.input}
                                onChange={this.normalizeSize(
                                    Width.input.onChange, 
                                    convertedRange.MinWidth, 
                                    convertedRange.MaxWidth
                                )}
                                onBlur={() =>
                                    this.handleWidthChange
                                }
                                className="width hidden-on-small"
                            /> */}
                        </span>
                    </div>  

                </Row>
            </Column>
            <Column small={12} className="unit-selector">
            <span
                    onClick={() =>
                        this.toggleUnit("m", conservatoryWidth, conservatoryHeight)
                    }
                    className={(unit === "m" ? "selected" : "")}
                >
                    metre
                </span>
                <span
                    onClick={() =>
                        this.toggleUnit("ft", conservatoryWidth, conservatoryHeight)
                    }
                    className={(unit === "ft" ? "selected" : "")}
                >
                    foot
                </span>
            </Column>
            </Row>);
    }
}


// WEBPACK FOOTER //
// ./src/containers/ConservatoryForm/SelectSize.js